/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';

import IMG from '../img/Web_RGB_3n_MTMT_IGN-CNIG.png';//'../img/LogoWEBIGN.png';
import IMGCabecera from '../img/cabecera_web_logo_MaaC.png';
import IMGFacebook from '../img/facebook.png';
import IMGInstagram from '../img/instagram.png';
import IMGPinterest from '../img/pinterest.png';
import IMGRSS from '../img/rss.png';
import IMGtuiter from '../img/tuiter.png';
import IMGYoutube from '../img/youtube.png';
import IMGAyuda from '../img/logo-ayuda.png';
import IMGLlamadaMac from '../img/llamada.png';

import LoginAdminPopup from '../components/LoginAdminPopup.jsx';

import LocalStorage from '../service/LocalStorage';

import i18n from '../resources/i18n';
import {properties} from '../resources/properties.js';

const lngs = {
  es: { nativeName: 'Castellano' },
  ca: { nativeName: 'Català' },
  eu: { nativeName: 'Euskara' },
  gl: { nativeName: 'Galego' },
  en: { nativeName: 'English' },
};

class Cabecera extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.loginConfirmed = false;
    this.showAdminLogin = props.showAdminLogin || false;
  }

  setStateGlobal = (state) => {
    const { setParentStateSteps } = this.props;
    setParentStateSteps(state);
  }

  changeLanguage = (option) => {
    let {parentState} = this.props;
    parentState.lng = option;
    i18n.changeLanguage(option);
    if (parentState.main !== undefined) {
      window.location.reload();
    } else {
      this.setStateGlobal(parentState);
    }
  }

  render() {
    let testLogin;
    if(this.showAdminLogin){
      testLogin= LocalStorage.get('login-cookie');// POSIBLEMENTE ES MEJOR MOVERLO FUERA DE AQUí con otro metodo de saber su estado antes de llegar aquí
      if(testLogin && testLogin.fecha > new Date().getTime()){
        this.loginConfirmed = (testLogin.token === properties.TOKEN);
      }else{
        LocalStorage.delete('login-cookie');
        this.loginConfirmed = false;
      }
      testLogin = null;
    }
    return (
      <header >
        <div id="langContainer" className="site-language pull-right">
          {Object.keys(lngs).map((lng) => (
            i18n.language.toString().includes(lng) ?
            <React.Fragment key={lng}>
              <span className="taglib-language-list-text">{lngs[lng].nativeName} </span>
            </React.Fragment> :
            <React.Fragment key={lng}>
              <a className="fakeLink taglib-language-list-text" onClick={() => this.changeLanguage(lng)}>{lngs[lng].nativeName}</a>
            </React.Fragment>
          ))}
        </div>
        <div id="headerMain">
          <div id="headerLeft">
            <a href="https://www.transportes.gob.es/" target="_blank" rel="noopener noreferrer" title="Ministerio de Transportes y Movilidad Sostenible">
              <img className="logo-gob" src={IMG} alt='Logo GOB'></img>
            </a>
          </div>
          <div id="headerCenter">
            <a href={properties.apiURLApiService}>
              <img className="logo-MAC" title="Inicio" src={IMGCabecera} alt='Logo MAC'></img>
            </a>
            <a href={properties.apiURLApiService} className="displayOnlyMobile logoMobile">Mapa a la carta</a>
            <a href={properties.apiURLApiService} className="displayOnlyMobile logoCnigMob">Centro Nacional de Información Geográfica</a>
          </div >
          <div id="headerRight">
            <div id="social" style={{
                "paddingRight" : "15px"
              }}>
              <a className="linkCab" href="https://www.youtube.com/playlist?list=PLLemwiHg3TanNN_P1p15OJdcifUhAVJpB" target="_blank" rel="noopener noreferrer">
                <img id="social" src={IMGAyuda} className="widthRRSS logoHelp" title="Ayuda" alt="Ayuda"/>
              </a>
              <a className="linkCab" href="https://www.ign.es/web/ign/portal/servicios-ciudadano/mapa-a-la-carta/servicio" target="_blank" rel="noopener noreferrer">
                <img id="social" src={IMGLlamadaMac} className="widthRRSS" title="Llamada a Mapa a la Carta" alt="Llamada a Mapa a la Carta"/>
              </a>
              <a className="linkCab" href="http://www.facebook.com/pages/Instituto-Geografico-Nacional-de-Espana-CNIG/156297191073688#!/pages/Instituto-Geografico-Nacional-de-Espana-CNIG/156297191073688?v=wall" target="_blank" rel="noopener noreferrer">
                  <img id="social" src={IMGFacebook} className="widthRRSS" title="Facebook" alt="Facebook"/>
              </a>

              <a className="linkCab" href="https://twitter.com/IGNSpain" target="_blank" rel="noopener noreferrer">
                <img id="social" src={IMGtuiter} className="widthRRSS" title="Twitter" alt="Twitter"/>
              </a>
              <a className="linkCab" href="https://www.instagram.com/ignspain/" title="Instagram" target="_blank" rel="noopener noreferrer">
                <img id="social" src={IMGInstagram} className="widthRRSS" title="Instagram" alt="Instagram"/>
              </a>

              <a className="linkCab" href="https://www.pinterest.es/IGNSpain/" title="Pinterest" target="_blank" rel="noopener noreferrer">
                <img id="social" src={IMGPinterest} className="widthRRSS" title="Pinterest" alt="Pinterest"/>
              </a>

              <a className="linkCab" href="http://www.youtube.com/user/IGNSpain" title="Youtube" target="_blank" rel="noopener noreferrer">
                <img id="social" src={IMGYoutube} className="widthRRSS" title="Youtube" alt="Youtube"/>
              </a>
              <a className="linkCab" href="http://www.ign.es/web/ign/portal/social-rss" title="RSS" target="_blank" rel="noopener noreferrer">
                <img id="social" src={IMGRSS} className="widthRRSS" title="RSS" alt="RSS"/>
              </a>
            </div>

            {this.showAdminLogin && (<LoginAdminPopup active={this.loginConfirmed} setRowStatus={()=>this.setStateGlobal({})}/>)}
          </div>
        </div>
      </header>
    );
  }
}

export default Cabecera;
